<app-modal id="qr-code-modal" #modalComponent>
    <div class="qr-code-modal-container">
        <h2 class="font-h2 title-text">{{ "app.modal.qr.instruction" | translate }}</h2>
        @if (link) {
            <qrcode [qrdata]="link" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        }
    </div>
</app-modal>
